import { LoadablePaint } from '@confluence/loadable';

export const LazyPermissionsExportPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PermissionsExportPage" */ '../src/PermissionsExport/PermissionsExportPage'
			)
		).PermissionsExportPage,
});
